import { render, staticRenderFns } from "./Nuevo-pase-cuenta-cliente.vue?vue&type=template&id=29179e67&scoped=true"
import script from "./Nuevo-pase-cuenta-cliente.vue?vue&type=script&lang=js"
export * from "./Nuevo-pase-cuenta-cliente.vue?vue&type=script&lang=js"
import style0 from "./Nuevo-pase-cuenta-cliente.vue?vue&type=style&index=0&id=29179e67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29179e67",
  null
  
)

export default component.exports